import { render, staticRenderFns } from "./RedirectPagePalla.vue?vue&type=template&id=1444374c&scoped=true&"
import script from "./RedirectPagePalla.vue?vue&type=script&lang=js&"
export * from "./RedirectPagePalla.vue?vue&type=script&lang=js&"
import style0 from "./RedirectPagePalla.vue?vue&type=style&index=0&id=1444374c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1444374c",
  null
  
)

export default component.exports